/** General room clock: server epoch mapped onto performance.now(), never Date.now(). */
export interface ClockSample { clientSentMs: number; serverReceivedMs: number; serverSentMs: number; clientReceivedMs: number }
export class RoomClock {
  private offset: number | null = null;
  private target = 0;
  private bestRtt = Infinity;
  private lastRead = 0;
  private lastValue = -Infinity;
  private samples = 0;
  private ready = false;
  private lastSampleAt = -Infinity;
  constructor(private readonly monotonicNow: () => number = () => performance.now()) {}
  beginBurst() { this.bestRtt = Infinity; }
  endBurst() {
    if (!this.ready && this.samples >= 3 && this.offset !== null) {
      this.offset = this.target; this.lastRead = this.monotonicNow(); this.ready = true;
    }
  }
  reset() { this.offset = null; this.target = 0; this.bestRtt = Infinity; this.samples = 0; this.ready = false; this.lastValue = -Infinity; this.lastSampleAt = -Infinity; }
  add(sample: ClockSample): boolean {
    const { clientSentMs: t0, serverReceivedMs: t1, serverSentMs: t2, clientReceivedMs: t3 } = sample;
    if (![t0, t1, t2, t3].every(Number.isFinite) || t3 < t0 || t2 < t1) return false;
    const rtt = (t3 - t0) - (t2 - t1);
    if (rtt < 0 || rtt > 5000) return false;
    this.samples++;
    if (rtt <= this.bestRtt) {
      this.target = ((t1 - t0) + (t2 - t3)) / 2;
      this.bestRtt = rtt; this.lastSampleAt = t3;
      // First burst converges before playback is armed. Subsequent bursts slew.
      if (!this.ready) { this.offset = this.target; this.lastRead = t3; }
    }
    return true;
  }
  now(): number | null {
    if (this.offset === null || !this.ready) return null;
    const local = this.monotonicNow();
    if (local - this.lastSampleAt > 90000) return null;
    const maxSlew = Math.max(0, local - this.lastRead) * 0.002;
    this.offset += Math.max(-maxSlew, Math.min(maxSlew, this.target - this.offset));
    this.lastRead = local;
    const value = Math.max(this.lastValue, local + this.offset);
    this.lastValue = value; return value;
  }
  get roundTripMs() { return this.bestRtt; }
}
